import axios from 'axios';
import {REP_API_URL , API_URL} from '../utils/constants.js';

class BonusService {
    async getStaticPage(permalink){
        const url = `${API_URL}get-static-page/${permalink}/`;
        const headers = {
            'Content-Type': 'application/json'
        };
        return axios({
            url:url,
            method: 'GET',
            headers: headers
        }).then(function(response){
            return response;
        }).catch(function(error){
            return error.response;
        });
    }

    async submitImprovementIdea(data){
        const url = `${REP_API_URL}submit-improvement-idea/`;
        const headers = {
            'Content-Type': 'application/json'
        };
        return axios({
            url:url,
            method: 'POST',
            headers: headers,
            data: data
        }).then(function(response){
            return response;
        }).catch(function(error){
            return error.response;
        });
    }
}

export default BonusService;